import React from 'react';

type PlusIconProps = {
  size?: number;
  color?: string;
};

const PlusIcon: React.FC<PlusIconProps> = ({ size = 16, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M10 4V16" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M4 10H16" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default PlusIcon;

